import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { IconName, ButtonVariant, PopoverPosition, DropdownOptionGroup, ButtonSize, ButtonType, DropdownSelectionType, DropdownOptionDefault, DropdownOptionType, DropdownOption } from '@yupma/ui-kit';
import { EmailValue, EmailLabel, EntityType } from 'server-model';
import { CRMFieldDataService, IAMService } from 'src/app/services/services.module';

interface DisplayEmailValue extends EmailValue {
  isUnique: boolean;
  isDropdownOpen: boolean;
}

@Component({
  selector: 'app-email-edit-popover',
  templateUrl: './email-edit-popover.component.html',
  styleUrl: './email-edit-popover.component.scss'
})
export class EmailEditPopoverComponent {
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() value: EmailValue[] = [];
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = true;
  @Input() error: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Output() updateEmails = new EventEmitter<EmailValue[]>()
  @Output() close = new EventEmitter()

  displayEmailValue: DisplayEmailValue[] = [];
  iconNames = IconName;
  buttonVariants = ButtonVariant;
  popoverPositions = PopoverPosition;
  labelDropdownOptions: DropdownOptionGroup[] = [];
  buttonSizes = ButtonSize;
  buttonTypes = ButtonType;
  dropdownSelectionTypes = DropdownSelectionType;

  constructor(
    private iamService: IAMService,
    private crmFieldDataService: CRMFieldDataService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!!(changes['value'])) {
      this.createDispalyEmailValue()
    }
  }


  ngOnInit() {
    this.createDispalyEmailValue()
  }


  private createDispalyEmailValue() {
    this.createLabelDropdown()
    if (this.value && this.value.length) {
      this.displayEmailValue = this.value.map((email) => ({
        ...email,
        isUnique: true,
        isDropdownOpen: false,
      }));
    } else {
      this.displayEmailValue = [{ label: EmailLabel.WORK, value: "", primary: true, isUnique: true, isDropdownOpen: false, }]
    }
  }

  private createLabelDropdown() {
    let work = new DropdownOptionDefault(DropdownOptionType.DEFAULT, EmailLabel.WORK, EmailLabel.WORK);
    let personal = new DropdownOptionDefault(DropdownOptionType.DEFAULT, EmailLabel.PERSONAL, EmailLabel.PERSONAL);
    let other = new DropdownOptionDefault(DropdownOptionType.DEFAULT, EmailLabel.OTHER, EmailLabel.OTHER);
    let labelGroup = new DropdownOptionGroup('', [work, personal, other]);
    this.labelDropdownOptions = [labelGroup];
  }

  toggleLabelDropdown(index: number, state: boolean) {
    this.displayEmailValue[index].isDropdownOpen = state;
    if (state === true) {
      this.labelDropdownOptions[0].options.forEach((option) => {
        option.selected = option.label === this.displayEmailValue[index].label;
      });
    }
  }

  updateLabel(index: number, newLabel: DropdownOption) {
    this.displayEmailValue[index].label = newLabel.value as EmailLabel;
  }

  updateValue(index: number, newValue: string, email: DisplayEmailValue) {
    this.displayEmailValue[index].value = newValue;
    this.checkUniqueValue(newValue, email);
  }

  removeEmail(index: number) {
    this.displayEmailValue.splice(index, 1);

    if (this.displayEmailValue.length > 0) {
      this.displayEmailValue[0].primary = true;
    }
  }

  addEmail() {
    this.displayEmailValue.push({
      label: EmailLabel.WORK,
      value: '',
      primary: false,
      isUnique: true,
      isDropdownOpen: false,
    });
  }

  // submitEmails() {
  //   const emailValues: EmailValue[] = this.displayEmailValue
  //     .filter(email => email.value.trim() !== '') // Exclude entries with empty 'value'
  //     .map(({ isDropdownOpen, ...emailValue }) => emailValue);

  //   this.updateEmails.emit(emailValues);
  //   this.close.emit();
  // }

  submitEmails() {
    const emailValues: EmailValue[] = [];

    const uniqueEmails = new Map<string, EmailValue>();

    // Filter and consolidate email values
    this.displayEmailValue.forEach(email => {
      const trimmedValue = email.value.trim();
      if (trimmedValue !== '') {
        if (!uniqueEmails.has(trimmedValue)) {
          uniqueEmails.set(trimmedValue, {
            label: email.label,
            value: trimmedValue,
            primary: email.primary,
          });
        }
      }
    });

    // Check if all isUnique are true
    const allUnique = this.displayEmailValue.every(email => email.isUnique);

    if (allUnique) {
      emailValues.push(...uniqueEmails.values());
      this.updateEmails.emit(emailValues);
      this.close.emit();
    }
  }

  closePopover() {
    this.close.emit();
  }


  async checkUniqueValue(value: any, field: DisplayEmailValue) {
    try {
      const organisationId = this.iamService.getOrganisationId();
      let isUnique = [];
      isUnique = (await this.crmFieldDataService.validateField(organisationId, EntityType.CONTACT, [{ name: this.name, value: value }])).data;
      if (isUnique.length) {
        field.isUnique = false;
      } else {
        field.isUnique = true;
      }
    } catch (error) {
      console.log(error)
    }
  }
}
